import React from 'react';
import { useInput } from 'react-admin';
import { ImageUploadField } from './ImageUploadField';

interface ImageUploadInputProps {
    source: string;
    label?: string;
    helperText?: string;
    required?: boolean;
}

export const ImageUploadInput: React.FC<ImageUploadInputProps> = ({
    source,
    label,
    helperText,
    required
}) => {
    const {
        field,
        fieldState: { error },
    } = useInput({ source });

    return (
        <ImageUploadField
            source={source}
            value={field.value}
            onChange={field.onChange}
            label={label}
            helperText={helperText}
            required={required}
        />
    );
};